exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Accordion__content{opacity:0;transition:opacity 250ms linear}.Accordion__content.visible{opacity:1}", ""]);
